import { QcBizDictSchema } from "@/modules/admin/objects/bizDicts";
import { z } from "zod";
import { QcBizLocationGroupSchema } from "./conversation/QcBizLocationGroup";
import { QcBizMainMenuSchema } from "./conversation/MainMenu";
import { QcBizSubMenuSchema } from "./guest/SubMenu";

export type TenantName = z.infer<typeof TenantNameSchema>;
export const TenantNameSchema = z.object({
  id: z.number(),
  tenant_id: z.number(),
  dict_cd: z.string(),
  lang_cd: z.string(),
  message: z.string(),
});

export type Currency = z.infer<typeof CurrencySchema>;
export const CurrencySchema = z.object({
  ISO_code: z.string(),
  country: z.string(),
  currency_name: z.string(),
  currency_symbol: z.string(),
  id: z.number(),
});

export type Tenant = z.infer<typeof TenantSchema>;
export const TenantSchema = z.object({
  id: z.number(),
  code: z.string(),
  tenant_type: z.string(),
  ask_location_type: z.string(),
  admin_tenant_flg: z.boolean(),
  inquiry_reject_enabled: z.boolean(),
  survey_rating_enabled: z.boolean(),
  name_dict: z.string(),
  pictures: z.array(z.string()),
  logo: z.string(),
  theme: z.string(),
  background_image: z.string(),
  custom_dictionary_id: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  default_staff_icon: z.string(),
  names: z.array(TenantNameSchema),
  descriptions: z.array(TenantNameSchema),
  currency: CurrencySchema,
});

export type QcBizTenant = z.infer<typeof QcBizTenantSchema>;
export const QcBizTenantSchema = z.object({
  admin_tenant_flg: z.boolean().optional(),
  ask_location_type: z.string().optional(),
  background_image: z.string().optional(),
  cc_status_visible: z.boolean().optional(),
  code: z.string().optional(),
  currency: z.array(CurrencySchema).optional(),
  current_lang_cd: z.string().optional(),
  custom_dictionary_id: z.string().optional(),
  dch_hotel_id: z.string().optional(),
  default_staff_icon: z.string().optional(),
  description_dict: z.string().optional(),
  descriptions: z.array(QcBizDictSchema).optional(),
  id: z.number().optional(),
  inquiry_reject_enabled: z.boolean().optional(),
  is_client: z.boolean().optional(),
  lang_cd: z.string().optional(),
  latitude: z.number().optional(),
  location_groups: z.array(QcBizLocationGroupSchema).optional(),
  logo: z.string().optional(),
  logo_url: z.string().optional(),
  longitude: z.number().optional(),
  main_menus: z.array(QcBizMainMenuSchema).optional(),
  name: z.string().optional(),
  name_dict: z.string().optional(),
  names: z.array(QcBizDictSchema).optional(),
  picture: z.string().optional(),
  qr_invite_staff: z.string().optional(),
  ring_strategy: z.number().optional(),
  routing_strategy: z.number().optional(),
  secondary_lang_cd: z.string().optional(),
  strategy_type: z.string().optional(),
  sub_menus: z.array(z.lazy(() => QcBizSubMenuSchema)).optional(),
  survey_rating_enabled: z.boolean().optional(),
  tenant_type: z.string().optional(),
  theme: z.string().optional(),
  widget_on_off: z.boolean().optional(),
});
